import { createSelector } from 'reselect';
import { getGdsServicesCalculatedCountInfoSelector } from '@shared/lib/gdsService/getGdsServicesCalculatedCountInfoSelector';
const getOrder = (state) => state.order;
const getAdditionalServices = createSelector(getOrder, order => order.additionalServices);
const getGdsServices = createSelector(getAdditionalServices, additionalServices => { var _a, _b; return (_b = (_a = additionalServices === null || additionalServices === void 0 ? void 0 : additionalServices.gdsServices) === null || _a === void 0 ? void 0 : _a.services) !== null && _b !== void 0 ? _b : []; });
const getServicesRestrictionsByType = createSelector(getOrder, order => { var _a, _b, _c; return (_c = (_b = (_a = order.additionalServices) === null || _a === void 0 ? void 0 : _a.gdsServices) === null || _b === void 0 ? void 0 : _b.servicesRestrictionsByType) !== null && _c !== void 0 ? _c : []; });
const getSegments = createSelector(getOrder, order => { var _a, _b; return (_b = (_a = order.flight) === null || _a === void 0 ? void 0 : _a.segments) !== null && _b !== void 0 ? _b : []; });
const getSegmentIds = createSelector(getSegments, segments => { var _a; return (_a = segments === null || segments === void 0 ? void 0 : segments.map(segment => segment.segment.id)) !== null && _a !== void 0 ? _a : []; });
const getPassengerIds = (state) => state.passengers.map(passenger => passenger.id);
const getSelectedServicesState = (state) => state.selectedServices;
export const getGdsSelectedServicesCountInfo = createSelector(getGdsServices, getSelectedServicesState, (gdsServices, selectedServices) => {
    var _a, _b;
    const gdsServiceMap = new Map(gdsServices.map(service => [service.id, service]));
    const result = {};
    for (const passengerId in selectedServices) {
        const passengerServices = selectedServices[passengerId];
        for (const serviceId in passengerServices) {
            const services = passengerServices[serviceId];
            for (const selectedService of services) {
                const serviceInfo = gdsServiceMap === null || gdsServiceMap === void 0 ? void 0 : gdsServiceMap.get((_a = selectedService === null || selectedService === void 0 ? void 0 : selectedService.servicePayload) === null || _a === void 0 ? void 0 : _a.id);
                if (!serviceInfo) {
                    console.warn(`Service info not found for ID: ${(_b = selectedService === null || selectedService === void 0 ? void 0 : selectedService.servicePayload) === null || _b === void 0 ? void 0 : _b.id}`);
                    continue;
                }
                const rfisc = serviceInfo.rfisc;
                const type = serviceInfo.type;
                let subType;
                const count = selectedService.number;
                if (serviceInfo.baggageType) {
                    subType = serviceInfo
                        .baggageType;
                }
                if (serviceInfo.subType) {
                    subType = serviceInfo.subType;
                }
                // Initialize passenger entry if it doesn't exist
                if (!result[passengerId]) {
                    result[passengerId] = {
                        segments: {},
                        total: { rfisc: {}, type: {}, subType: {} }
                    };
                }
                // Update total rfisc count
                result[passengerId].total.rfisc[rfisc] = Number(result[passengerId].total.rfisc[rfisc] || 0) + count;
                // Update total type count
                result[passengerId].total.type[type] = Number(result[passengerId].total.type[type] || 0) + count;
                // Update total subType count if subType exists
                if (subType) {
                    result[passengerId].total.subType[subType] =
                        Number(result[passengerId].total.subType[subType] || 0) + count;
                }
                // Update segment-specific counts
                for (const segmentId of selectedService.segments) {
                    if (!result[passengerId].segments[segmentId]) {
                        result[passengerId].segments[segmentId] = {
                            rfisc: {},
                            type: {},
                            subType: {}
                        };
                    }
                    // Update segment rfisc count
                    result[passengerId].segments[segmentId].rfisc[rfisc] =
                        Number(result[passengerId].segments[segmentId].rfisc[rfisc] || 0) + count;
                    // Update segment type count
                    result[passengerId].segments[segmentId].type[type] =
                        Number(result[passengerId].segments[segmentId].type[type] || 0) + count;
                    // Update segment subType count if subType exists
                    if (subType) {
                        result[passengerId].segments[segmentId].subType[subType] =
                            Number(result[passengerId].segments[segmentId].subType[subType] || 0) + count;
                    }
                }
            }
        }
    }
    return result;
});
export const getGdsServicesCalculatedCountInfo = createSelector(getPassengerIds, getSegmentIds, getServicesRestrictionsByType, getGdsSelectedServicesCountInfo, getGdsServicesCalculatedCountInfoSelector);
